module.exports = __webpack_public_path__ + "static/assets/37368a504fc2b894a30cd5c5f4760d86.svg";